module.exports = __webpack_public_path__ + "static/media/me.8096e4aa.svg";